<template>
  <!-- :fill-height="!$vuetify.breakpoint.xsOnly" -->
 <v-container fluid fill-height >
   <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="0">
          <!-- <v-card-title>Checkout</v-card-title> -->
          <v-card-text>
            <div id="checkout"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
      <LoadingDialog></LoadingDialog>
</v-container>
</template>

<script>
import api from "@/services/api";
import { server } from "../services/constants.js";
import { feature } from "../services/constants.js";
import LoadingDialog from "@/components/cards/LoadingDialog";

export default {
  name: "Contact",
  data: () => ({
    clientSecret: null,
    stripe:null,
    showpop: false,
    dateNow: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .replace("T", " ")
      .substr(0, 16),
    margincardpriceplans: "mx-auto ml-0 mt-0 mr-0 mb-0",
    width: 420,
    width_emp: 600,
    text_fontsize: 30,
    privacy_sta: "false",
    privacyDlg: false,
  }),
  components: {
      LoadingDialog,
    },
   async beforeCreate() {
      this.$store.state.page_reload = false;
    },
    async mounted() {
  //       if (!sessionStorage.getItem("reloaded")) {
  //   sessionStorage.setItem("reloaded", "true");
  //   // location.href = window.location.reload(true); 
  //   window.location.reload(true); // reload 1 ครั้ง
  // } else {
  //   sessionStorage.removeItem("reloaded"); // เคลียร์ flag ไว้ใช้รอบถัดไป
  // }
      const userId = localStorage.getItem(server.USER_ID);
       if (userId && !api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }

    try {
      // โหลด stripe แค่ครั้งเดียว
      // this.stripe = await getStripe();
       await this.loadsession();
      // console.log(window.Stripe)
  //     if (!window.Stripe || !this.stripe) {
  //   // this.stripe = window.Stripe("pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19");
  //   //  this.stripe = await loadStripe("pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19");
  //     setTimeout(async() => {
  //       await this.loadsession();
  //     }, 2000); 
  // } else {
  //   console.error("Stripe.js failed to load");
  // }
      // this.stripe = await loadStripe("pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19");
      // if (!this.stripe) throw new Error('Stripe not loaded');
      // console.log('Stripe loaded', this.stripe);
      
    } catch (err) {
      // console.error("Stripe init error:", err);
        this.$swal.fire("Error", err, "error");
        this.$router.back();
        // this.$router.push("/pricing");
    }

    
    
    },
    computed: {
  buttonsmall() {
     if(this.$vuetify.breakpoint.name === "xs"){
       return true;
     }
      },
    widthbutton() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "75%";
        case "sm":
          return "76%";
        case "md":
          return "60%";
        case "lg":
          return "40%";
        case "xl":
          return "40%";
      }
    },
    widthheightimage(){
 switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "300";
        case "sm":
          return "400";
        case "md":
          return "400";
        case "lg":
          return "400";
        case "xl":
          return "400";
      }
      },
    },
    methods: {
      async loadsession(){
         this.$store.state.loadMenu = true;
    
    //  const stripe = await loadStripe('pk_test_51Nn1nlAXAFZfMq9NdFPD4Cignl0WpECylmPArkIZdUyPIcTGslmJRgvXPSkQfaooK43d2oXkyol1HHolnXsXu2uU00fI8sGL19');
     const checkemil =  await api.checkemailstripepayment({email:localStorage.getItem(server.USERNAME)});
      if(checkemil.data && checkemil.data.customer_email){
        this.$store.state.loadMenu = false;
        localStorage.removeItem(feature.GET_BUY_NOW);
        this.onClickMenu("/listroom");
         return;

    }else{
   const result =  await api.checkoutstripepayment({plan:localStorage.getItem(feature.GET_BUY_NOW),email:localStorage.getItem(server.USERNAME)});
       this.$store.state.loadMenu = false;
       localStorage.removeItem(feature.GET_BUY_NOW);
     if(result.data.portal){
      window.location.href = result.data.portal.url;
//  let win;
//  win = window.open(
//         `${result.data.portal.url}`,
//         "_blank"
//       );
//        if (win && !win.closed) {
//         // console.log("✅ New tab opened successfully");
//       } else {
//         // console.warn("❌ Failed to open new tab (possibly blocked by popup blocker)");
//       }

      this.onClickMenu("/listroom");

      return;
     }
       if(result.data.session.url){
     window.location.href = result.data.session.url;
      return;
     }
     return;
  
     }
      this.clientSecret = result.data.checkoutSessionID;
      // this.$route.params.client_secret

        const checkout = await this.stripe.redirectToCheckout({
        sessionId:this.clientSecret
      });

    //  const checkout = await this.stripe.initEmbeddedCheckout({
    //       clientSecret:this.$route.params.client_secret
    //     });


          
         checkout.mount("#checkout");
         localStorage.removeItem(feature.GET_BUY_NOW);
        this.$store.state.loadMenu = false;
      },
      onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
    },
};
</script>


<style scoped>

@media only screen and (max-width: 320px)  {
  .v-application {
    margin-top:-50px;
  }
  
}
  @media only screen and (min-width: 320px) and (max-width: 599px)  {
  /* .mainpage-container {
    margin-top:-150px;
  } */
  .v-application {
    margin-top:-50px;
    /* height: 110% !important; */
  }
  
}
@media only screen and (min-width: 600px) and (max-width: 960px)  {
  .homefeature{
    height:80vh !important;
  }
}

@media (min-width: 960px) {
  .mainpage-container {
    margin-top: 3rem
  }
}

.v-main {
    overflow:auto;
    /* max-width: 100%;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important; */
}

.homefeature{
  background-image: linear-gradient(to right top, #cbe9f8, #dcedfc, #ebf2fd, #f7f8fe, #ffffff) !important;
    /* height: 60vh; */
    width: 100%;
}
.homepricing{
  background-image: linear-gradient(to bottom, #95bef2, #99c0f2, #9dc2f2, #a0c4f2, #a4c6f2) !important;
    /* height: 50vh; */
    width: 100%;
    align-content: center;
}
.homegettotouch{
  background-color: #19396A !important;
    /* height: 50vh; */
    width: 100%;
    align-content: center;
}

.homepricing_paragraph{
  transform: translateY(20px);
  opacity: 0;
  transition: 2s ease;
}
.homepricing_paragraph--visible{
  transform: translateY(0);
  opacity: 1;
}

ul, #myUL {
  list-style-type: none;
}

#myUL {
  margin: 0;
  padding: 0;
}

.caret {
  font-size:19.5px;
  font-weight:300;
  cursor: pointer;
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
}

.caret::before {
  content: "\25B6";
  color: black;
  display: inline-block;
  margin-right: 6px;
}

.caret-down::before {
  -ms-transform: rotate(90deg); 
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);  
}

.nested {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size:19.5px;
  font-weight:300;
  display: none;
}

.active {
  display: block;
}
 .row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start; /* หรือ center ตามความต้องการ */
  }

  .row ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .wrap-text {
  -webkit-line-clamp: unset !important;
}

 .transparent-background {
      background-color: transparent !important;
      box-shadow: none !important;
    }
    sup{
          /* top: -1.5em !important; */
          margin-right: 10px;
    }
</style>
